import axios from "axios"
import config from "../config"
import Vue from "vue";
const moduleStore = {
    state: {
        userList: [],
    },
    mutations: {
    },
    actions: {
        async exportQrCourse(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/exportQrCourse`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async exportCefCourse(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/exportCefCourse`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async exportCourseAreaOfStudyMap(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/exportCourseAreaOfStudyMap`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async exportCourseDeliveryModeMap(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/exportCourseDeliveryModeMap`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async exportCourseLevelMap(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/exportCourseLevelMap`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
        async exportCourseCipVtcMap(context, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    let result = await axios.post(`${config.domain}/exportCourseCipVtcMap`, data)
                    
                    if (result.data.errorCode === 0) {
                        resolve(result)
                    } else {
                        context.commit("setwarning", {
                            string: result.data.errorMessage,
                            boolean: true,
                            button: [{
                              name:"Cancel",
                              callBack:function(){}
                            }]
                        })
                        resolve(false)
                    }
                }
                catch (err) {
                    
                    reject(err)
                }
            })
        },
    },
    getters: {
    }
}

export default moduleStore;